<template>
  <Flex column container>
    <div class="all-rows">
      <GroupProgressItem
        v-for="(group, index) in sortedGroups"
        :key="group"
        :group="group"
        :hasData="!!progressData(group)"
        :hasDataVisible="hasDataVisible(group)"
        :progress="progressData(group).progress"
        :nameTitle="`${group}${noDataInfo(group)}`"
        :progressBarTitle="progressBarTitle(group)"
        :alwaysVisible="index < 25"
      />
    </div>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import { mapGetters } from 'vuex'
import GroupProgressItem from './GroupProgressItem'

export default {
  name: 'GroupProgress',
  components: {
    Flex,
    GroupProgressItem,
  },
  computed: {
    ...mapGetters('SustainabilityData', ['groups', 'groupProgress']),
    sortedGroups() {
      const names = Object.keys(this.groupProgress())
      names.sort()
      return names
    },
  },
  methods: {
    progressData(group) {
      return this.groupProgress()?.[group]
    },
    progressBarTitle(group) {
      const data = this.progressData(group)
      if (data) {
        const total = data.completed + data.outstanding
        const percentage = Math.round(data.progress)
        return `${this.$t('progress')}: ${
          data.completed
        } / ${total} (${percentage}%)${this.noDataInfo(group)}`
      }
      return ''
    },
    hasDataVisible(group) {
      return this.groups.includes(group)
    },
    noDataInfo(group) {
      if (!this.hasDataVisible(group)) {
        return `\n${this.$t('noDataVisible')}`
      }
      return ''
    },
  },
}
</script>

<style lang="postcss" scoped>
.container {
  @apply overflow-y-scroll p-8 text-sm cursor-default;
}
.all-rows {
  @apply border-b border-r;
}
</style>
